import React, { FC } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { PayerData } from "./PayerData";
import { TransferAmounts } from "./TransferAmounts";
import { TransferPaymentDetails } from "./TransferPaymentDetails";
import { ROUTES } from "../../routes";
import { useGetPaymentRequestLinkPublicQuery } from "../../store/services/paymentRequestLinks";
import { selectStep } from "../../store/reducers/paymentRequestLink";
import { PaymentRequestLinkPublicLayout } from "../../layouts/PaymentRequestLinkPublicLayout";

export const PaymentRequestLinkPage: FC = () => {
  const { id } = useParams();
  useGetPaymentRequestLinkPublicQuery(id || "");
  const step = useSelector(selectStep);

  if (!id) {
    return <Navigate to={ROUTES.NOT_FOUND} />;
  }

  let content;
  if (step === 0) {
    content = <TransferAmounts />;
  } else if (step === 1) {
    content = <PayerData />;
  } else {
    content = <TransferPaymentDetails />;
  }

  return (
    <PaymentRequestLinkPublicLayout>{content}</PaymentRequestLinkPublicLayout>
  );
};
